import { IBaseDtoType } from './common.type'
import { ERewardPointsTypes } from './reward-points.type'
import { IConsumerScanBaseWithId } from './scan-to-earn.type'

export interface IRewardActivityBase {
  type: ERewardPointsTypes
  amount: string
  status: ERewardActivityStatus
  consumerScan: IConsumerScanBaseWithId
  payload: IRewardActicityPayload
}

export interface IRewardActivityBaseWithId extends IRewardActivityBase, IBaseDtoType {}

export interface IRewardActivityRespDto {
  count: number
  data: (IRewardActivityBaseWithId & {
    referralUser?: { id: string; email: string; name: string } | null
  })[]
}

export enum ERewardActivityStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  DECLINED = 'declined',
}

export interface IRewardActicityPayload {
  referral_user_id?: string
  decline_reason?: string
  challenges?: IRewardActicityChallenge[]
  trai_challenge_info?: {
    challenge: IRewardActicityChallenge
    trai: number
    points: number
  }
  approval_feedbacks?: string[]
}

export interface IRewardActicityChallenge {
  id: string
  name: string
}
